export enum BoatApplicationDocumentType {
	ownershipCertificate = "ownershipCertificate",
	internationalMeasuringCertificate = "internationalMeasuringCertificate",
	classificationCertificate = "classificationCertificate",
	internationalOilPollutionPreventionCertificate = "internationalOilPollutionPreventionCertificate",
	customDocuments = "customDocuments"
}
